import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChipSymbolBar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 18,
	viewBox: "0 0 48 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 48,
		height: 18,
		rx: 9,
		fill: "white"
	}), /* @__PURE__ */ _jsx("rect", {
		x: 3,
		y: 2,
		width: 42,
		height: 14,
		rx: 7,
		fill: "#424242"
	})]
});
export default SvgChipSymbolBar;
